<template>
  <div class="myInfoInputImgWrapper">
    <input ref="imageInput" type="file" hidden v-on:change="onChangeImages">
    <img class="myInfoInputImg" v-bind:src="imageUrl">
    <div class="overlayImgWrapper" v-bind:style="style.inputImgEditable">
      <img class="overlayImg" v-bind:src="iconUrl" v-on:click="onClickIcon">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgIndex: Number,
    initImgUrl: String
  },
  data () {
    return {
      isImageSet: false,
      imageUrl: '',
      iconUrl: '',
      style: {
        inputImgEditable: ''
      }
    }
  },
  methods: {
    init () {
      // 이미지 상태 설정
      if(this.initImgUrl == null) {
        this.isImageSet = false
        this.iconUrl = require('@/assets/img/add_image_icon.png')
        this.imageUrl = require('@/assets/img/myInfo_default_img.png')
      }else{
        this.isImageSet = true
        this.iconUrl = require('@/assets/img/remove_image_icon.png')
        this.imageUrl = this.initImgUrl
      }
      // 수정상태(동그란 아이콘) 표시 설정
      this.style.inputImgEditable = this.$store.getters.getMyInfoStateValue('isEditable') ? 'display: block;' : ''
      // tempImgStore 초기화
      this.$store.commit('setTempImgStore', {index: this.imgIndex, value: null})
    },
    onClickIcon () {
      if(!this.isImageSet) {
        this.$refs.imageInput.click()
      }else{
        this.iconUrl = require('@/assets/img/add_image_icon.png')
        this.imageUrl = require('@/assets/img/myInfo_default_img.png')
        this.isImageSet = false
        // value: false ==> 기존이미지 삭제, value: null ==> 변경하지 않음
        this.$store.commit('setTempImgStore', {index: this.imgIndex, value: false})
        this.$refs.imageInput.value = null
      }
    },
    onChangeImages (e) {
      let pathPoint = e.target.files[0].name.lastIndexOf('.')
      let fileType = e.target.files[0].name.substring(pathPoint + 1, e.target.files[0].name.length).toLowerCase()

      if (fileType === 'jpg' || fileType === 'jpeg' || fileType === 'gif' || fileType === 'png' || fileType === 'bmp' || fileType === '') {
        const file = e.target.files[0]
        this.imageUrl = URL.createObjectURL(file)
        this.isImageSet = true
        this.$store.commit('setTempImgStore', {index: this.imgIndex, value: file})
      }else {
        alert('이미지 파일을 선택 해 주세요.')
        this.imageUrl = this.initImgUrl == null ? require('@/assets/img/myInfo_default_img.png') : this.initImgUrl
        this.$store.commit('setTempImgStore', {index: this.imgIndex, value: null})
      }
    }
  },
  watch: {
    isImageSet: function () {
      this.iconUrl = this.isImageSet ? require('@/assets/img/remove_image_icon.png') : require('@/assets/img/add_image_icon.png')
    }
  },
  created: function () {
    this.init()
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getMyInfoStateValue('isEditable'), value => {
      this.style.inputImgEditable = value ? 'display: block;' : ''
    })
    this.$store.watch(() => this.$store.getters.getMyInfoStateValue('imgReloadTrigger'), value => {
      // myInfo에서 취소 버튼을 눌렀을시 트리거됨. init 처리
      this.init()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type='text']{
  padding: 0;
  font-size: 22px;
  width: 100%;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  outline: none;
}

span {
  font-size: 12px;
}

.myInfoInputImgWrapper {
  position: relative;
  width: 100%;
  height: 100%;
  margin-top: 20px;
  margin-right: 20px;
}

.myInfoInputImg{
  width: 100%;
  height: 100%;
}

.overlayImgWrapper{
  display: none;
  position: absolute;
  top: calc(100% - 42px);
  left: calc(100% - 42px);
}

.overlayImg{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/myInfoInputImg.vue